import { TYPE } from 'theme';
import React from 'react';
import { isMobile } from 'react-device-detect';

interface Props {
    fontSize?: number;
    fontWeight?: number;
    color?: string;
    customClass?: string;
    children: React.ReactNode;
    align?: 'left' | 'center' | 'right';
    style?: React.CSSProperties;
}
const colors = {
    main: '#65dbcf',
};

export default function Text({
    fontSize,
    fontWeight,
    color,
    customClass,
    children,
    align = 'left',
    style,
}: Props) {
    return (
        <span
            className={customClass}
            style={{
                fontSize: `${fontSize}px`,
                fontWeight: fontWeight,
                color:
                    color && colors[color as keyof typeof colors]
                        ? colors[color as keyof typeof colors]
                        : color,
                textAlign: align,
                ...style,
            }}
        >
            {children}
        </span>
    );
}

export const Title = (props: Props) => {
    const { children, ...rest } = props;
    return (
        <TYPE.main fontSize={28} fontWeight={500} {...rest}>
            {props.children}
        </TYPE.main>
    );
};

export const SecondTitle = (props: Props) => {
    const { children, ...rest } = props;
    return (
        <TYPE.main fontSize={24} fontWeight={500} {...rest}>
            {props.children}
        </TYPE.main>
    );
};

export const ThirdTitle = (props: Props) => {
    const { children, ...rest } = props;
    return (
        <TYPE.main fontSize={18} fontWeight={500} {...rest}>
            {props.children}
        </TYPE.main>
    );
};

export const Info = (props: Props) => {
    const { children, ...rest } = props;
    return (
        <TYPE.main
            fontSize={isMobile ? 10 : 15}
            fontWeight={500}
            color="#7493AD"
            {...rest}
        >
            {children}
        </TYPE.main>
    );
};

export const Error = (props: Props) => {
    return (
        <TYPE.main fontSize={12} fontWeight={500} color="red">
            {props.children}
        </TYPE.main>
    );
};

export const Warning = (props: Props) => {
    const { children, ...rest } = props;
    return (
        <TYPE.main fontSize={8} fontWeight={500} color="#FFB200" {...rest}>
            {children}
        </TYPE.main>
    );
};
